import { ServicePermissions } from "@screens/login/LoginVerification";

export const API_ROUTES = {
  //user
  LOGIN_VERIFICATION: "/loginverification",
  GET_USER_BY_GROUP_ID: "/getcompanyusergroupbyid/:userGroupId",

  // company management
  GET_COMPANY_NODES: "/companynodes/:companyId",
  ADD_COMPANY: "/addcompany",
  UPDATE_COMPANY: "/updatecompany",
  GET_COMPANY: "/getcompany",
  ENABLE_DISABLE_COMPANY: "/enabledisablecompany",

  // service management
  GET_ALL_SERVICES: "/getAllServices",
  ADD_SERVICE: "/addservice",
  UPDATE_SERVICE: "/updateservice",
  GET_SERVICE: "/getservice",
  ENABLE_DISABLE_SERVICE: "/disableservice",

  GET_ALL_SERVICE_ENDPOINTS: "/getallserviceendpoints",
  GET_SERVICE_ENDPOINT: "/getserviceendpoints",
  ADD_SERVICE_ENDPOINT: "/addserviceendpoints",
  UPDATE_SERVICE_ENDPOINT: "/updateserviceendpoint",

  // user group
  GET_ALL_USER_GROUPS: "/getcompusrgrpbypcid",
  ADD_USER_GROUP: "/addcompanyusergroup",
  GET_USER_GROUP: "/getcompanyusergroupbyid",
  UPDATE_USER_GROUP: "/editcompanyusergroup",
  ENABLE_DISABLE_USER_GROUP: "/enabledisablecompanyusergroup",

  // user management
  GET_USER_GROUP_COMPANY: "/getcompusrgrpbycid",
  GET_ALL_USERS: "/getallcompanyuser",
  ADD_USER: "/addcompanyuser",
  GET_USER: "/getcompanyuser",
  UPDATE_USER: "/updatecompanyuser",
  ENABLE_DISABLE_USER: "/enabledisablecompanyuser",

  // AUTH
  AUTH_ME: "/auth/me",
  LOGOUT: "/logout",

  // CMS
  CMS_LOGIN_VERIFICATION: "/org/login-verification",
};

export function hasPermission(
  rolePermissions: ServicePermissions,
  serviceCode: string,
  endpointCode: string,
): boolean {
  return (
    rolePermissions[serviceCode] &&
    rolePermissions[serviceCode][endpointCode] === true
  );
}

export const showValue = (value: any): string => {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return "N/A";
  }
  return String(value);
};
